// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/about.scss
// module id = 49
// module chunks = 0